import { useEffect, useRef, useState } from 'react';
import { Button, Group, Select } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { employeesService, type EmployeeView } from '../../../services/employees/employees.service';
import { adminOrdersService } from '../../../services/admin-orders/admin-orders.service';

export const OrderEmployeeReassignment = ({ tenantId, orderId, currentName, currentEmployeeId }: {
  tenantId: string;
  orderId: number;
  currentName: string | null;
  currentEmployeeId: number | null;
}) => {
  const [employees, setEmployees] = useState<EmployeeView[]>([]);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const inFlight = useRef(false);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setSelectedId(null);
    setEmployees([]);
    void employeesService.listActive(tenantId).then((rows) => {
      if (active) setEmployees(rows.filter((employee) => employee.isActive));
    }).catch(() => {
      if (active) notifications.show({ color: 'red', message: 'טעינת העובדים נכשלה' });
    }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [tenantId, orderId]);

  const save = async () => {
    if (!selectedId || Number(selectedId) === currentEmployeeId || inFlight.current) return;
    inFlight.current = true;
    setSaving(true);
    try {
      await adminOrdersService.updateOpeningWaiter(tenantId, orderId, Number(selectedId));
      setSelectedId(null);
      notifications.show({ color: 'green', message: 'העובד להזמנה עודכן' });
    } catch {
      notifications.show({ color: 'red', message: 'עדכון העובד להזמנה נכשל' });
    } finally {
      inFlight.current = false;
      setSaving(false);
    }
  };

  return <Group align="end" wrap="wrap">
    <Select label="שיוך מכירות לעובד" placeholder={currentName ?? 'בחר עובד'}
      data={employees.map((employee) => ({ value: String(employee.id), label: employee.fullName }))}
      value={selectedId} onChange={setSelectedId} disabled={loading || saving} />
    <Button onClick={() => { void save(); }} loading={saving} disabled={!selectedId || Number(selectedId) === currentEmployeeId || loading}>שמור</Button>
  </Group>;
};